import { FaceAuthentication, Authentication, AuthenticationResult, SearchAuthentication } from './faceAuthentication';
import FacetecFaceAuthentication from './facetec';

import NullFaceAuthentication from './nullFaceAuthentication';

const isE2e =
  (process.env.REACT_APP_STAGE || 'unknown') === 'e2e' || (process.env.REACT_APP_STAGE || 'unknown') === 'preprod_e2e';
const isMock = (process.env.REACT_APP_STAGE || 'unknown') === 'mock';
const faceAuthentication: FaceAuthentication =
  isE2e || isMock ? new NullFaceAuthentication() : new FacetecFaceAuthentication();

export default faceAuthentication;
export type { AuthenticationResult, Authentication, SearchAuthentication };
